(function () {
  'use strict';

  angular
    .module('sbMenu', ['ngAnimate', 'ngResource', 'ngCookies', 'ngTouch',
      'ngSanitize',
      'ngMessages', 'ngAria', 'restangular', 'ui.router', 'ui.bootstrap',
      'mwl.calendar', 'dndLists', 'treasure-overlay-spinner',
      'darthwade.dwLoading', 'ngTable', 'formly', 'formlyBootstrap',
      'dialogs.main', 'ngToast', 'ui.select', 'ui.bootstrap.dropdown',
      'ui.bootstrap.popover', 'ui.router.components', 'naif.base64',
      'angular-cache',
      'bsLoadingOverlay', 'angular.vertilize', 'daterangepicker',
      'mgcrea.jquery', 'btford.markdown',
      'uiSwitch', 'schoolBitezFoundation', 'mgcrea.bootstrap.affix',
      'ngFileUpload', 'ngHolder', 'angularjs-dropdown-multiselect',
      'textAngular', 'yaru22.angular-timeago', 'ui.utils.masks',
      'ngclipboard', 'bm.uiTour', 'chart.js'
    ]);

})();

(function () {
  angular.module("sbMenu").component("schoolMenuDirectory", {
    templateUrl: "app/schoolMenuDirectory.html",
    bindings: {},
    controller: SchoolMenuDirectoryController,
    controllerAs: "vm",
  });

  function SchoolMenuDirectoryController(
    $scope,
    $translate,
    LanguageService,
    Restangular,
    FeatureNames,
    ThemeService,
    PreferenceService,
    BeanUtils
  ) {
    var vm = this;

    vm.$onInit = function () {
      Restangular.one("bean/catererForDomain")
        .get()
        .then(function (catererProfile) {
          vm.catererProfile = catererProfile;
          ThemeService.updateThemeColorFromCatererProfile(vm.catererProfile);
          vm.menuNotAvailable =
            vm.catererProfile.settings.publishMenuDirectory === "false";
          if (vm.catererProfile.settings.publishMenuDirectory) {
            loadLanguages(vm.catererProfile);
            loadSchoolGroups().then(function () {
              loadSchoolList().then(function () {
                watchSchoolGroup();
              });
            });
          }
        });
      loadFeatures();

      $scope.$on("hasBreakfastItems", function (event, hasBreakfastItems) {
        vm.hasBreakfastItems = hasBreakfastItems;
      });

      $scope.$watch("vm.selectedLanguage", function () {
        if (vm.selectedLanguage) {
          $translate.use(vm.selectedLanguage);
          PreferenceService.savePreference(
            "consumer.language",
            vm.selectedLanguage
          );
        }
      });
    };

    function loadLanguages(catererProfile) {
      var preferredLang =
        PreferenceService.getPreferenceValue2("consumer.language");
      preferredLang = preferredLang || "en-US";
      vm.selectedLanguage = preferredLang;
      $translate.use(preferredLang);

      vm.languages =
        catererProfile &&
        catererProfile.settings &&
        catererProfile.settings.languages
          ? LanguageService.availableLanguagesForParent(
              catererProfile.settings.languages
            )
          : [];
    }

    function watchSchoolGroup() {
      $scope.$watch("vm.selectedSchoolGroup", function () {
        if (vm.selectedSchoolGroup) {
          filterSchools();
        }
      });
    }

    function loadSchoolGroups() {
      return Restangular.all("menu/schoolGroups")
        .getList()
        .then(function (schoolGroups) {
          vm.schoolGroups = schoolGroups;
          BeanUtils.sortObjectsByNumberProperty(
            vm.schoolGroups,
            "displayOrder"
          );
        });
    }

    function filterSchools() {
      vm.schools = vm.allSchools.filter(function (school) {
        return (
          !vm.selectedSchoolGroup ||
          (school.schoolGroup &&
            school.schoolGroup.id === vm.selectedSchoolGroup.id)
        );
      });
    }

    function loadFeatures() {
      return Restangular.all("menu/enabledFeatures")
        .getList()
        .then(function (features) {
          vm.featureMap = features.reduce(function (featureMap, feature) {
            featureMap[feature.module] = feature.enabled;
            return featureMap;
          }, {});
          vm.schoolGroupsEnabled = vm.featureMap[FeatureNames.SCHOOL_GROUPS];
        });
    }

    function loadSchoolList() {
      return Restangular.all("menu/schoolList")
        .getList()
        .then(function (schools) {
          vm.allSchools = schools;
          vm.schools = schools;
          BeanUtils.sortObjectsByStringProperty(vm.allSchools, "name");
          filterSchools();
        });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('sbMenu')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $location, ngToast, $log, Restangular, $state,
    $http, uiTourService,
    SecurityService, timeAgoSettings) {

    createPolyFills();


    $rootScope.navigateToAndWaitFor = function(tour, state, stepId) {
      $location.path(state);
      return tour.waitFor(stepId);
    }

    var oneDay = 60 * 60 * 24;
    timeAgoSettings.fullDateAfterSeconds = oneDay;

    /*
    $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams,
      fromState, fromParams) {
      ngToast.dismiss();
      //console.log("$stateChangeSuccess " + fromState.name + JSON.stringify(
      //fromParams) + " -> " + toState.name + JSON.stringify(toParams));
    });
    */

    /* sends jwt token with every request */
    Restangular.addFullRequestInterceptor(function(element, operation, what,
      url, headers) {
      var returned = {
        'headers': headers || {}
      }
      var jwtToken = SecurityService.getAuthToken();
      //$log.log("Sending token " + jwtToken + " with request");
      returned.headers["Authorization"] = "Bearer " + jwtToken;
      return returned;
    });


    Restangular.setErrorInterceptor(function(response) {
      if (response.status === 401 && response.config.url.indexOf('login') ===
        -1 && response.config.url.indexOf('saLogin') === -1) {
        $state.go('login', {
          routingMessage: 'PLEASE_LOG_IN'
        });
      }
    });
    $log.debug('runBlock end');


    function createPolyFills() {

      //substring polyfill for IE
      if (!String.prototype.startsWith) {
        String.prototype.startsWith = function(searchString, position) {
          position = position || 0;
          return this.indexOf(searchString, position) === position;
        };
      }
      if (!String.prototype.endsWith) {
        String.prototype.endsWith = function(suffix) {
          return this.indexOf(suffix, this.length - suffix.length) !== -1;
        };
      }
    }
  }
})();

(function() {
  'use strict';

  var routerConfig = function($stateProvider, $urlRouterProvider,
    BeanClassNames) {
    "ngInject";
    $stateProvider
      .state('embeddableSchoolMenu', {
        url: '/embeddableSchoolMenu?schoolKey?type',
        component: 'embeddedSchoolMenu'
      }).state('menuDirectory', {
        url: '/menuDirectory?provider',
        component: 'schoolMenuDirectory'
      });

    $urlRouterProvider.otherwise('/menuDirectory');
  };

  routerConfig.$inject = ['$stateProvider', '$urlRouterProvider',
    'BeanClassNames'
  ];

  angular
    .module('sbMenu')
    .config(routerConfig);

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('sbMenu')
    .constant('moment', moment);

})();

(function () {
  "use strict";

  angular.module("sbMenu").config(config);

  /** @ngInject */
  function config(
    $logProvider,
    RestangularProvider,
    formlyConfigProvider,
    ngToastProvider,
    $translateProvider,
    CacheFactoryProvider,
    localStorageServiceProvider,
    TourConfigProvider,
    ChartJsProvider
  ) {
    "ngInject";

    localStorageServiceProvider.setStorageType("sessionStorage");

    // Enable log
    $logProvider.debugEnabled(true);
    $translateProvider.preferredLanguage("en-US");
    $translateProvider.useUrlLoader("rest/caterer/api/menu/labels");

    //localStorage is used for storing JWT token
    localStorageServiceProvider.setStorageType("sessionStorage");

    RestangularProvider.setDefaultHeaders({
      "If-Modified-Since": "Mon, 26 Jul 1997 05:00:00 GMT",
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    });
    /*
    $translateProvider.translations('en-US', {
      DIALOGS_CLOSE: "Close",
      DIALOGS_YES: "Yes",
      DIALOGS_NO: "No"
    })
    */

    $translateProvider.preferredLanguage("en-US");

    // Set options third-party lib
    /*
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
    */
    ngToastProvider.configure({
      horizontalPosition: "center",
      maxNumber: 1,
      additionalClasses: "col-sm-6",
      animation: "fade", // or 'fade'
    });

    RestangularProvider.setBaseUrl("rest/caterer/api");
  }
})();

(function() {

  angular.module('sbMenu').component('embeddedSchoolMenu', {
    templateUrl: 'app/embeddedSchoolMenu.html',
    bindings: {
    },
    controller: EmbeddedSchoolMenuController,
    controllerAs: 'vm'
  });


  function EmbeddedSchoolMenuController($stateParams,ConsumerLoginService,ThemeService,
    Restangular) {

    var vm = this;

    vm.$onInit = function() {
      vm.schoolKey = $stateParams.schoolKey;

      ConsumerLoginService.getCatererProfile().then(function (catererProfile) {
        vm.catererProfile = catererProfile;
        if (vm.catererProfile != undefined) {
          ThemeService.updateThemeColorFromCatererProfile(vm.catererProfile);
        }
      })

      vm.type = $stateParams.type;
      fetchArticle();
    };


    function fetchArticle() {
      Restangular.oneUrl("menu").customGET("parentHelp/" + vm.schoolKey,
        undefined, undefined, {
          'Accept': 'text/plain'
        }).then(function(article) {
        vm.articleContent = article;
      });
    }
  }
})();

(function () {
  angular.module("sbMenu").component("embedSchoolMenu", {
    templateUrl: "app/embedSchoolMenu.html",
    bindings: {
      schoolKey: "<",
      settings: "<?",
    },
    controller: SchoolMenuController,
    controllerAs: "vm",
  });

  function SchoolMenuController(CalendarService, Restangular, moment) {
    "ngInject";
    var vm = this;

    vm.$onInit = function () {
      vm.menuTypeNames = [];
      // filled by the shared calendar with print() / hasItems()
      vm.calendarApi = {};
      vm.showPics = vm.settings && vm.settings.showPicsInMenu === "true";

      var month = moment.tz(CalendarService.getMenuTimeZone()).date(1);
      vm.calendarMonth = CalendarService.removeTime(month);
      loadMenu();
    };

    // Reloads when the host swaps the school after the first render.
    // The first change is handled by $onInit, which also sets the month.
    vm.$onChanges = function (changes) {
      if (changes.schoolKey && !changes.schoolKey.isFirstChange()) {
        loadMenu();
      }
    };

    // Switches the calendar to another menu type (Breakfast / Lunch tab).
    // The shared calendar re-groups the already loaded payload; no reload.
    vm.setFilter = function (menuType) {
      vm.filterBy = menuType;
    };

    // Prints just the calendar (not the tabs) via the calendar component's api.
    // The button lives here so it lines up with the menu-type tabs.
    vm.print = function () {
      vm.calendarApi.print();
    };

    // True once the calendar has items to print for the shown month and type.
    // Guards against clicking before the component has published its api.
    vm.canPrint = function () {
      return !vm.loading && !!vm.calendarApi.hasItems && vm.calendarApi.hasItems();
    };

    // Called by the shared calendar's prev/next arrows.
    // This host owns the month, so it stores it and loads that month's menu.
    vm.onMonthChange = function (calendarMonth) {
      vm.calendarMonth = calendarMonth;
      loadMenu();
    };

    // Loads the public menu payload for the school + month.
    // Keeps the selected menu type when the new month still has it.
    function loadMenu() {
      if (!vm.schoolKey) {
        return;
      }
      vm.loading = true;
      return Restangular.one(
        "menu/embeddableSchoolMenu/" +
          vm.schoolKey +
          "/" +
          vm.calendarMonth.valueOf()
      )
        .get()
        .then(function (scheduleData) {
          vm.menuData = scheduleData.plain();
          vm.menuTypeNames = [];
          angular.forEach(vm.menuData.itemToDaysMap, function (schedules, menuType) {
            if (Object.keys(schedules).length > 0) {
              vm.menuTypeNames.push(menuType);
            }
          });
          if (vm.menuTypeNames.indexOf(vm.filterBy) === -1) {
            vm.filterBy = vm.menuTypeNames[0];
          }
        })
        .finally(function () {
          vm.loading = false;
        });
    }
  }
})();

angular.module("sbMenu").run(["$templateCache", function($templateCache) {$templateCache.put("app/embedSchoolMenu.html","<div class=\"container-fluid menu-container\"><treasure-overlay-spinner active=\"vm.loading\"><div class=\"flex flex-col gap-4\"><div class=\"flex gap-8 items-center\"><div class=\"flex gap-8 flex-1\"><div class=\"menu-type\" ng-class=\"{\'active\':vm.filterBy === menuType}\" ng-repeat=\"menuType in vm.menuTypeNames\" ng-if=\"vm.menuTypeNames.length > 1\" ng-click=\"vm.setFilter(menuType)\">{{menuType}}</div></div><button type=\"button\" class=\"btn-sm btn btn-default\" ng-disabled=\"!vm.canPrint()\" ng-click=\"vm.print()\"><i class=\"fa fa-print\"></i> Print</button></div><school-menu-calendar menu-data=\"vm.menuData\" menu-type-name=\"vm.filterBy\" calendar-month=\"vm.calendarMonth\" allow-period-change=\"true\" on-month-change=\"vm.onMonthChange(calendarMonth)\" show-pics=\"vm.showPics\" loading=\"vm.loading\" api=\"vm.calendarApi\"></school-menu-calendar></div></treasure-overlay-spinner></div>");
$templateCache.put("app/embeddedSchoolMenu.html","<div class=\"container\"><div class=\"row\"><div class=\"col-sm-1-12\"><div class=\"main-container\"><div class=\"row\" ng-if=\"vm.type == \'calendar\'\"><div class=\"col-sm-12\"><embed-school-menu school-key=\"vm.schoolKey\"></embed-school-menu></div></div><div class=\"row\" ng-if=\"vm.type == \'instructions\'\"><div class=\"col-sm-12\"><div class=\"col-sm-12 no-padding\"><div class=\"article-content\" ng-bind-html=\"vm.articleContent\"></div></div></div></div><div class=\"row\" ng-if=\"vm.type == \'calendarAndInstructions\'\"><div class=\"col-sm-12\"><uib-tabset><uib-tab heading=\"Menu\"><div class=\"col-sm-12 no-padding\"><embed-school-menu school-key=\"vm.schoolKey\"></embed-school-menu></div></uib-tab><uib-tab heading=\"Ordering Instructions\"><div class=\"col-sm-12 no-padding\"><div class=\"article-content\" ng-bind-html=\"vm.articleContent\"></div></div></uib-tab></uib-tabset></div></div></div></div></div></div>");
$templateCache.put("app/schoolMenuDirectory.html","<div class=\"container flex flex-col gap-8 menu-directory\"><div class=\"flex items-center gap-8\"><div class=\"logo-holder\"><img ng-style=\"{\'background-color\' : vm.catererProfile.logoBackgroundColor }\" class=\"img-thumbnail small-logo\" ng-src=\"{{vm.catererProfile.logoImage}}\" alt=\"Logo\" ng-show=\"vm.catererProfile.logoImage\"></div><span class=\"flex-1 text-center menu-header-text\">{{\'label.schoolMenu\' | translate}}</span><language-selector ng-if=\"vm.languages.length > 1\" ng-model=\"vm.selectedLanguage\" selection-mode=\"\'radio\'\" selection-changed=\"vm.labelLanguageChanged(model)\" languages=\"vm.languages\"></language-selector></div><div ng-if=\"vm.menuNotAvailable\" class=\"flex items-center justify-center\"><p class=\"text-danger\">{{\'msg.noMenusAvailable\' | translate}}.</p></div><div ng-if=\"!vm.menuNotAvailable\" class=\"flex gap-8 items-center\"><div class=\"flex-1 flex items-center\"><label ng-if=\"vm.schoolGroupsEnabled\">{{\'entityLabel.schoolGroup\' | translate}}</label><div class=\"col-sm-6\" ng-if=\"vm.schoolGroupsEnabled\"><bean-select beans=\"vm.schoolGroups\" select-first=\"true\" ng-model=\"vm.selectedSchoolGroup\"></bean-select></div><label>{{\'entityLabel.school\' | translate}}</label><div class=\"col-sm-6\"><bean-select beans=\"vm.schools\" select-first=\"true\" ng-model=\"vm.selectedSchool\"></bean-select></div></div><div class=\"justify-end\" ng-if=\"vm.selectedSchool && !vm.selectedSchool.menuOnly\"><a target=\"_blank\" href=\"{{vm.catererProfile.frontendUrl}}\" class=\"cta-btn\">{{\'label.startOrder\' | translate}}</a></div></div><div ng-if=\"vm.selectedSchool\"><embed-school-menu school-key=\"vm.selectedSchool.publicIdentifier\" settings=\"vm.catererProfile.settings\"></embed-school-menu></div></div>");}]);